import React from "react";
import { Redirect } from "react-router-dom";
import { Form, Loader, Message } from "semantic-ui-react";
import styled from "styled-components";
import IdentityApi from "../api/IdentityApi";
import { ErrorMessages } from "../Constants";
import { isPasswordFormatValid } from "../util/regexHelper";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import MainContentWrapper from "./common/MainContentWrapper";
import PasswordRequirement from "./common/PasswordRequirement";
import PillButton from "./common/PillButton";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import ErrorDisplay from "./ErrorDisplay";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 100;
`;

const HeaderText = styled.div`
  font-size: 16px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 20px;
  margin-top: 50px;
  text-align: center;
`;

class ChangePassword extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      password: null,
      passwordConfirm: null,
      passwordsValid: false,
      passwordsEntered: false,
      showActivityIndicator: false,
      buttonDisabled: true,
      showSuccessMessage: false,
    };
    this.changePassword = this.changePassword.bind(this);
    this.validateEntry = this.validateEntry.bind(this);
    this.checkConfirmPassword = this.checkConfirmPassword.bind(this);

  }

  async changePassword() {
    const password = this.state.password;

    this.errorManager.reset();

    if (password === null || password === "") {
      this.errorManager.addError("You must enter a password to register");
      this.forceUpdate();
      return;
    }

    this.setState({ showActivityIndicator: true });
    this.forceUpdate();

    const auth = new IdentityApi();
    let response;

    try {
      response = await auth.changePasswordUsingToken(
        this.params.email,
        this.state.password,
        this.params.token
      );
    } catch (err) {
      console.log(err);
      if (err.response) {
        switch (err.response.status) {
          case 500:
            this.errorManager.addError("Unexpected Error");
            break;
          default:
            this.errorManager.addError("Unknown Error: " + err);
        }
        this.errorManager.addError(err.response.data);
      }
      this.setState({ showActivityIndicator: false });
      this.forceUpdate();
      return;
    }

    if (!response.data) {
      this.errorManager.addError("There was a problem changing your password.");
      this.setState({ showActivityIndicator: false });
      this.forceUpdate();
      return;
    }

    this.setState({
      showSuccessMessage: true,
      showActivityIndicator: false,
    });
  }

  checkConfirmPassword(value) {
    if (this.state.password === value) {
      this.validateEntry();
    }
  }

  validateEntry() {
    this.errorManager.reset();
    if (this.state.password != null && this.state.passwordConfirm != null) {
      //somethign in there for everything. Start validating.

      if (!isPasswordFormatValid(this.state.password)) {
        this.errorManager.addError(ErrorMessages.PASSWORD_FORMAT_FAILED);
        this.forceUpdate();
        return;
      }

      //check passwords for entry and equality
      if (this.state.password != null && this.state.passwordConfirm != null) {
        this.setState({ passwordsEntered: true });
      } else {
        this.setState({ passwordsEntered: false });
      }

      if (this.state.password !== this.state.passwordConfirm) {
        this.setState({ passwordsValid: false });
        return;
      }

      if (this.state.password.length < 8) {
        this.setState({ passwordsValid: false });
        return;
      }

      //need to test for certain characters - really need regex at this point
      this.setState({ passwordsValid: true });
    }
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Password Reset" />
        <SFLoader active={this.state.showActivityIndicator} />
        <MainContentWrapper>
          <Wrapper>
            <HeaderText>
              Enter your new password below and click
              <br />
              Change Password.
            </HeaderText>

            <Loader active={this.state.loaderActive} />
            <Form.Input
              onChange={(e) => {
                this.setState({ password: e.target.value });
              }}
              onBlur={(e) => {
                this.validateEntry();
              }}
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              autoComplete="new-password"
              style={{ width: "250px" }}
            />
            <Form.Input
              onChange={(e) => {
                this.checkConfirmPassword(e.target.value);
                this.setState({ passwordConfirm: e.target.value });
              }}
              onBlur={(e) => {
                this.validateEntry();
              }}
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Confirm"
              type="password"
              autoComplete="new-password"
              style={{ width: "250px" }}
            />

            <PasswordRequirement
              style={{
                marginBottom: 30,
                marginTop: 30,
                marginLeft: 30,
                marginRight: 30,
                fontSize: 16,
                textAlign: "left",
              }}
            />

            {this.errorManager.getErrorCount() > 0 ? (
              <ErrorDisplay errorManager={this.errorManager} />
            ) : null}
            <PillButton
              onClick={() => {
                this.changePassword();
              }}
              loading={this.state.showActivityIndicator}
              primary
              disabled={
                !this.state.passwordsValid || this.state.showSuccessMessage
              }
            >
              Change Password
            </PillButton>
            {this.state.showSuccessMessage ? (
              <Message>
                Password changed successfully. You may now return to your app to login.
              </Message>
            ) : null}
          </Wrapper>
        </MainContentWrapper>
      </SiteWrapper>
    );
  }
}

export default ChangePassword;
